// src/components/AdminSettings/modals/PhotoAlbumModal.tsx
import React from 'react';
import { Modal, ModalSection } from '../../ui/Modal';
import { TextInput } from '../../ui/TextInput';
import type { PhotoAlbumModalProps } from '../types';

export const PhotoAlbumModal: React.FC<PhotoAlbumModalProps> = ({
  isOpen,
  onClose,
  editingAlbum,
  form,
  onFormChange,
  onSave,
  onDelete,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      header={{ title: editingAlbum ? 'Edit Album' : 'Create Album' }}
      footer={{
        primaryAction: {
          label: editingAlbum ? 'Save' : 'Create Album',
          onClick: onSave,
          disabled: !form.name.trim(),
        },
        secondaryAction: { label: 'Cancel', onClick: onClose },
        ...(editingAlbum && {
          tertiaryAction: {
            label: 'Delete',
            onClick: onDelete,
            variant: 'danger' as const,
          },
        }),
      }}
    >
      <ModalSection spacing="normal">
        <TextInput
          label="Album Name"
          value={form.name}
          onChange={(v) => onFormChange({ ...form, name: v })}
          placeholder="e.g., Family Photos, Vacation 2024"
          variant="default"
        />
        <p style={{
          fontSize: 13,
          color: 'var(--ion-color-medium)',
          marginTop: 16,
        }}>
          After creating an album, you can upload photos to it from the dashboard slideshow settings.
        </p>
      </ModalSection>
    </Modal>
  );
};

export default PhotoAlbumModal;
